import {i18n} from '@/plugins/i18n';

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: false,
        width: 60,
        textAlign: 'center',
    },
    {
        field: 'psp',
        title: i18n.t('label.psp'),
        sortable: false,
        textAlign: 'center',
        template: row => {
            switch (row.psp) {
                case 'mellat':
                    return '<div><img src="/assets/media/psp/mellat.png" width="32" height="32"></div>';
                case 'parsian':
                    return '<div><img src="/assets/media/psp/parsian.svg" width="32" height="32"></div>';
                case 'pasargad':
                    return '<div><img src="/assets/media/psp/pasargad.svg" width="32" height="32"></div>';
                case 'saman':
                    return '<div><img src="/assets/media/psp/saman.svg" width="32" height="32"></div>';
                case 'novin':
                    return '<div><img src="/assets/media/psp/novin.svg" width="32" height="32"></div>';
                case 'sepehr':
                    return '<div><img src="/assets/media/psp/sepehr.png" width="32" height="32"></div>';
                case 'irankish':
                    return '<div><img src="/assets/media/psp/irankish.png" width="32" height="32"></div>';
            }

            return `<span>${row.psp}</span>`;
        },
    },
    {
        field: 'user',
        title: i18n.t('label.user'),
        sortable: false,
        template: row => {
            if (!row.user) {
                return '-';
            }
            return `<a href="/users/${row.user.id}/details" target="_blank">${row.user.full_name}</a>`;
        },
        textAlign: 'center',
    },
    {
        field: 'terminal_number',
        title: i18n.t('label.terminal_number'),
        sortable: false,
        template: row => `<span dir="ltr">${row.terminal_number || '-'}</span>`,
        textAlign: 'center',
    },
    {
        field: 'account_number',
        title: i18n.t('label.sheba_number'),
        sortable: false,
        template: row => `<span dir="ltr">${row.account_number || '-'}</span>`,
        textAlign: 'center',
    },
    {
        field: 'pan',
        title: i18n.t('label.card_number'),
        sortable: false,
        template: row => `<span dir="ltr">${row.pan || '-'}</span>`,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount_rial'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'settlement_date',
        title: i18n.t('settlement.label.psp_settlement_date'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'draft_date',
        title: i18n.t('settlement.label.draft_date'),
        sortable: false,
        textAlign: 'center',
    },
]
